import './confirm_modal'
import { postForm } from '../lib/http'

function byId (id) { return document.getElementById(id) }
function bindClickPost (id, url) {
  const el = byId(id)
  if (el) el.addEventListener('click', function () {
    postForm(url, {}).catch(function () {})
  })
}

// TOGGLE SIDE MENU + pagina-wiring (vanilla; draait per Turbolinks-load)
document.addEventListener('turbo:load', function () {

  const btnMain = byId('btn-mainmenu')
  const mainMenu = byId('mainmenu')
  const userMenu = byId('usermenu')
  if (btnMain && mainMenu) {
    btnMain.addEventListener('mouseenter', function () {
      mainMenu.classList.add('open')
      if (userMenu) userMenu.classList.remove('open')
    })
    mainMenu.addEventListener('mouseleave', function () {
      mainMenu.classList.remove('open')
    })
  }

  const btnUser = byId('btn-usermenu')
  if (btnUser && userMenu) {
    btnUser.addEventListener('mouseenter', function () {
      userMenu.classList.add('open')
      if (mainMenu) mainMenu.classList.remove('open')
    })
    userMenu.addEventListener('mouseleave', function () {
      userMenu.classList.remove('open')
    })
  }

  // Info-popovers (ⓘ): native Bootstrap 5, hover-trigger.
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach(function (el) {
    if (window.bootstrap) window.bootstrap.Popover.getOrCreateInstance(el, { trigger: 'hover' })
  })

  // Flash-meldingen (alert-dismissible met data-autohide) sluiten zichzelf na
  // 5s — de × blijft werken voor wie niet wil wachten.
  document.querySelectorAll('.alert[data-autohide]').forEach(function (el) {
    setTimeout(function () {
      if (el.isConnected && window.bootstrap) {
        window.bootstrap.Alert.getOrCreateInstance(el).close();
      }
    }, 5000);
  });

  const copilot = byId('copilot')
  if (copilot) copilot.addEventListener('click', function () {
    document.querySelectorAll('[data-bs-toggle="popover"]').forEach(function (el) {
      el.classList.toggle('invisible')
    })
    postForm('/forecast/copilot', {}).catch(function () {})
  })

  bindClickPost('btn-forecast', '/forecast/runforecast')
  bindClickPost('export-forecast', '/forecast/runexport')
  bindClickPost('export-daily', '/forecast/runexportdaily')
  bindClickPost('export-week', '/forecast/runexportweekly')

  for (let e of document.querySelectorAll('input[type="range"]')) {
    e.style.setProperty('--value', e.value);
    e.style.setProperty('--min', e.min == '' ? '0' : e.min);
    e.style.setProperty('--max', e.max == '' ? '100' : e.max);
    e.addEventListener('input', () => e.style.setProperty('--value', e.value));
  }

  // Add animation if card enters viewport
  const container = document.querySelector(".container-fluid")
  const wrappers = document.querySelectorAll(".row")
  const cards = document.querySelectorAll(".card")

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return
      const currentIndex = Array.from(wrappers).indexOf(entry.target)
      const card = cards[currentIndex]
      if (!card) return // Skip if no matching card exists

      // Fade the card in once, then stop watching it. Toggling the class off
      // when the row scrolls away re-triggered the animation, and because the
      // fade starts at translateY(20%) the shifted card kept crossing the
      // threshold — an endless add/remove flicker loop on short pages (e.g. /me).
      card.classList.add("animated--fade-in-bottom")
      observer.unobserve(entry.target)
    })
  }, {
    root: container,
    threshold: 0.1,
  })


  wrappers.forEach(wrapper => {
    observer.observe(wrapper)
  })

})
